import { useLastVideoState } from '~/composables/shorts/useLastVideoState';
import { getOfflineViews } from '~/composables/usePropertyViewTracking';

export function useShortsNavigation() {
	const router = useRouter();
	const lastViewedPropertyCookie = useCookie<string>('last-viewed-property');

	function navigateToShorts(query?: Record<string, string>): void {
		router.push({ path: '/shorts', query });
	}

	function navigateToVideo(propertyId: string): void {
		router.push(`/shorts/${propertyId}`);
	}

	/**
	 * Redireciona para Shorts seguindo a regra dos 3 cenários:
	 * 1. Nunca acessou uma PDP → Home de Shorts (/shorts)
	 * 2. Acessou PDP, nunca consumiu Shorts → Reel do último imóvel visualizado na PDP
	 * 3. Acessou PDP e já consumiu Shorts → Último vídeo assistido no feed
	 */
	function navigateToShortsWithContext(): void {
		if (!import.meta.client) return;

		const lastPdpId = lastViewedPropertyCookie.value;
		const lastVideoId = useLastVideoState().get()?.propertyId;

		if (!lastPdpId) {
			return navigateToShorts();
		}

		const lastWatchedShortId = getOfflineViews().sort(
			(a, b) => (b.timestamp ?? 0) - (a.timestamp ?? 0)
		)[0]?.propertyId;

		navigateTo(`/shorts/${lastWatchedShortId ?? lastVideoId ?? lastPdpId}`);
	}
	return { navigateToShorts, navigateToVideo, navigateToShortsWithContext };
}
